'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function TextArea(_ref) {
    var label = _ref.label,
        feedback = _ref.feedback,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? (0, _idGen2.default)('textarea') : _ref$id,
        children = _ref.children,
        onChange = _ref.onChange,
        placeholder = _ref.placeholder,
        rows = _ref.rows;

    var onTextAreaChange = function onTextAreaChange(e) {
        if (onChange) {
            onChange(e.target.value);
        }
    };
    return _react2.default.createElement("div", { className: "luna-form__field" }, _react2.default.createElement("label", { className: "luna-label", htmlFor: id }, label), _react2.default.createElement("textarea", { className: "luna-input luna-input--textarea", rows: rows, placeholder: placeholder, "aria-describedby": id + '-feedback', id: id, onChange: onTextAreaChange }, children), feedback ? _react2.default.createElement("span", { className: "luna-form__feedback", id: id + '-feedback' }, feedback) : null);
};
TextArea.defaultProps = {
    placeholder: 'Text area',
    rows: 3
};
TextArea.propTypes = {
    label: _propTypes2.default.node.isRequired,
    feedback: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    placeholder: _propTypes2.default.string,
    rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    children: _propTypes2.default.string.isRequired
};
exports.default = TextArea;
//# sourceMappingURL=TextArea.js.map